// frontend/src/pages/CreateNewContentPage.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from '../components/common/Modal';
import CreateReelModal from '../components/reels/CreateReelModal';
import CreateMeetingModal from '../components/meetings/CreateMeetingModal';
import { PATHS } from '../router.jsx';
import { useModal } from '../contexts/ModalContext';
import { useAuth } from '../contexts/AuthContext';
import './CreateNewContentPage.css';

const CreateNewContentPage = () => {
  console.log('[CreateNewContentPage] Component rendering.');

  const navigate = useNavigate();
  const { openModal, closeModal } = useModal();
  const { user: currentUser } = useAuth();
  
  // State for modals
  const [showReelModal, setShowReelModal] = useState(false);
  const [showMeetingModal, setShowMeetingModal] = useState(false);
  
  console.log('[CreateNewContentPage] Modal states - Reel:', showReelModal, 'Meeting:', showMeetingModal);

  const handleCreateEvent = () => {
    console.log('[CreateNewContentPage] handleCreateEvent called.');
    closeModal();
    setTimeout(() => {
      navigate(PATHS.CREATE_EVENT_FORM || '/create-event');
    }, 100);
  };

  const handleCreateTask = () => {
    console.log('[CreateNewContentPage] handleCreateTask called.');
    closeModal();
    setTimeout(() => {
      navigate(PATHS.CREATE_TASK_FORM || '/create-task');
    }, 100);
  };

  const handleCreatePost = () => {
    console.log('[CreateNewContentPage] handleCreatePost called.');
    if (!currentUser?.id) {
      console.log('[CreateNewContentPage] User not logged in. Redirecting to login.');
      closeModal();
      setTimeout(() => {
        navigate(PATHS.LOGIN || '/auth/login');
      }, 100);
      return;
    }
    closeModal();
    setTimeout(() => {
      openModal('createPost');
    }, 100);
  };

  const handleShareThings = () => {
    console.log('[CreateNewContentPage] handleShareThings called.');
    closeModal();
    setTimeout(() => {
      navigate(PATHS.SHARE_SELECTION || '/share/select');
    }, 100);
  };

  const handleCreateVideo = () => {
    console.log('[CreateNewContentPage] handleCreateVideo called.');
    closeModal();
    setTimeout(() => {
      navigate(PATHS.CREATE_VIDEO || '/create-video');
    }, 100);
  };

  const handleCreateNewsArticle = () => {
    console.log('[CreateNewContentPage] handleCreateNewsArticle called.');
    closeModal();
    setTimeout(() => {
      navigate(PATHS.CREATE_NEWS || '/create-news');
    }, 100);
  };

  const handlePostJob = () => {
    console.log('[CreateNewContentPage] handlePostJob called.');
    closeModal();
    setTimeout(() => {
      navigate(PATHS.POST_JOB || '/post-job');
    }, 100);
  };

  const handleListItem = () => {
    console.log('[CreateNewContentPage] handleListItem called.');
    closeModal();
    setTimeout(() => {
      navigate(PATHS.LIST_ITEM || '/list-item');
    }, 100);
  };

  const handleOfferService = () => {
    console.log('[CreateNewContentPage] handleOfferService called.');
    closeModal();
    setTimeout(() => {
      navigate(PATHS.OFFER_SERVICE || '/offer-service');
    }, 100);
  };

  const handleCreateCommunity = () => {
    console.log('[CreateNewContentPage] handleCreateCommunity called.');
    closeModal();
    setTimeout(() => {
      navigate(PATHS.CREATE_COMMUNITY || '/create-community');
    }, 100);
  };

  const handleCreateDatingProfile = () => {
    console.log('[CreateNewContentPage] handleCreateDatingProfile called.');
    closeModal();
    setTimeout(() => {
      navigate(PATHS.CREATE_DATING_PROFILE || '/dating-profile');
    }, 100);
  };

  const handleRequestRide = () => {
    console.log('[CreateNewContentPage] handleRequestRide called.');
    closeModal();
    setTimeout(() => {
      navigate(PATHS.REQUEST_RIDE || '/request-ride');
    }, 100);
  };

  const handleOrderFood = () => {
    console.log('[CreateNewContentPage] handleOrderFood called.');
    closeModal();
    setTimeout(() => {
      navigate(PATHS.ORDER_FOOD || '/order-food');
    }, 100);
  };

  const handleShareMusic = () => {
    console.log('[CreateNewContentPage] handleShareMusic called.');
    closeModal();
    setTimeout(() => {
      navigate(PATHS.SHARE_MUSIC || '/share-music');
    }, 100);
  };

  const handleStartFundraiser = () => {
    console.log('[CreateNewContentPage] handleStartFundraiser called.');
    closeModal();
    setTimeout(() => {
      navigate(PATHS.START_FUNDRAISER || '/start-fundraiser');
    }, 100);
  };

  const handleCreateReel = () => {
    console.log('[CreateNewContentPage] handleCreateReel called.');
    setShowReelModal(true);
  };

  const handleCreateMeeting = () => {
    console.log('[CreateNewContentPage] handleCreateMeeting called.');
    setShowMeetingModal(true);
  };

  const handleReelSubmit = (reelData) => {
    console.log('[CreateNewContentPage] Reel submitted:', reelData);
    setShowReelModal(false);
    closeModal();
    
    alert('✅ Video Reel uploaded successfully!');
    
    if (PATHS.REELS) {
      setTimeout(() => {
        navigate(PATHS.REELS);
      }, 500);
    }
  };

  // ✅ FIXED: CreateMeetingModal already handles the API call, success message, and events
  // This callback is only called AFTER the modal successfully creates the meeting
  // We just need to close modals and optionally navigate
  const handleMeetingSubmit = async (meetingData) => {
    console.log('[CreateNewContentPage] Meeting successfully created:', meetingData);
    
    // The modal already handled:
    // - API call to /meetings/request or /meetings
    // - Success/error messages
    // - Event triggers (newRequestCreated)
    
    // Just close the modals
    setShowMeetingModal(false);
    closeModal();
    
    // Optional: Navigate to meetings page
    // (Comment this out if you want to stay on the current page)
    if (PATHS.MEETINGS || PATHS.CALENDAR) {
      setTimeout(() => {
        navigate(PATHS.MEETINGS || PATHS.CALENDAR || '/meetings');
      }, 500);
    }
  };

  const handleReelClose = () => {
    console.log('[CreateNewContentPage] Closing reel modal');
    setShowReelModal(false);
  };

  const handleMeetingClose = () => {
    console.log('[CreateNewContentPage] Closing meeting modal');
    setShowMeetingModal(false);
  };

  const handleCancel = () => {
    console.log('[CreateNewContentPage] Cancel button clicked. Closing modal.');
    closeModal();
  };

  return (
    <>
      {/* Main Create Options Modal */}
      <Modal
        isOpen={!showReelModal && !showMeetingModal}
        onClose={handleCancel}
        backdropDismiss={true}
        isCentered={true}
      >
        <div className="create-content-card">
          <h2 className="card-title">What would you like to do?</h2>

          <div className="create-options-scroll-container">
            {/* Content Creation */}
            <div className="mode-category">
              <h3 className="category-title">Content Creation</h3>
              
              <button
                type="button"
                className="secondary-button create-option-button"
                onClick={handleCreateVideo}
              >
                <span className="option-icon">📹</span>
                Create a Video
              </button>

              <button
                type="button"
                className="secondary-button create-option-button"
                onClick={handleCreateReel}
              >
                <span className="option-icon">🎥</span>
                Create Video Reel
              </button>

              <button
                type="button"
                className="secondary-button create-option-button"
                onClick={handleCreatePost}
              >
                <span className="option-icon">✏️</span>
                Create a Post
              </button>

              <button
                type="button"
                className="secondary-button create-option-button"
                onClick={handleCreateNewsArticle}
              >
                <span className="option-icon">📰</span>
                Create News Article
              </button>
            </div>

            {/* Professional/Commerce */}
            <div className="mode-category">
              <h3 className="category-title">Professional & Commerce</h3>
              
              <button
                type="button"
                className="secondary-button create-option-button"
                onClick={handlePostJob}
              >
                <span className="option-icon">💼</span>
                Post a Job
              </button>

              <button
                type="button"
                className="secondary-button create-option-button"
                onClick={handleListItem}
              >
                <span className="option-icon">🛍️</span>
                List an Item
              </button>

              <button
                type="button"
                className="secondary-button create-option-button"
                onClick={handleOfferService}
              >
                <span className="option-icon">🔧</span>
                Offer a Service
              </button>
            </div>

            {/* Social/Community */}
            <div className="mode-category">
              <h3 className="category-title">Social & Community</h3>
              
              <button
                type="button"
                className="secondary-button create-option-button"
                onClick={handleCreateCommunity}
              >
                <span className="option-icon">👥</span>
                Create a Community
              </button>

              <button
                type="button"
                className="primary-button create-option-button"
                onClick={handleCreateEvent}
              >
                <span className="option-icon">📅</span>
                Create an Event
              </button>

              <button
                type="button"
                className="secondary-button create-option-button"
                onClick={handleCreateMeeting}
              >
                <span className="option-icon">🤝</span>
                Schedule a Meeting
              </button>

              <button
                type="button"
                className="secondary-button create-option-button"
                onClick={handleCreateDatingProfile}
              >
                <span className="option-icon">💕</span>
                Create Dating Profile
              </button>
            </div>

            {/* Services */}
            <div className="mode-category">
              <h3 className="category-title">Services</h3>
              
              <button
                type="button"
                className="secondary-button create-option-button"
                onClick={handleRequestRide}
              >
                <span className="option-icon">🚕</span>
                Request a Ride
              </button>

              <button
                type="button"
                className="secondary-button create-option-button"
                onClick={handleOrderFood}
              >
                <span className="option-icon">🍔</span>
                Order Food
              </button>

              <button
                type="button"
                className="secondary-button create-option-button"
                onClick={handleShareMusic}
              >
                <span className="option-icon">🎵</span>
                Share Music
              </button>

              <button
                type="button"
                className="secondary-button create-option-button"
                onClick={handleStartFundraiser}
              >
                <span className="option-icon">💰</span>
                Start a Fundraiser
              </button>
            </div>

            {/* Tasks */}
            <div className="mode-category">
              <h3 className="category-title">Tasks</h3>
              
              <button
                type="button"
                className="secondary-button create-option-button"
                onClick={handleCreateTask}
              >
                <span className="option-icon">✓</span>
                Create a Task
              </button>

              <button
                type="button"
                className="secondary-button create-option-button"
                onClick={handleShareThings}
              >
                <span className="option-icon">🤝</span>
                Share Something
              </button>
            </div>
          </div>

          <button
            type="button"
            className="tertiary-button create-option-button cancel-button"
            onClick={handleCancel}
          >
            Cancel
          </button>
        </div>
      </Modal>

      {/* Video Reel Modal */}
      {showReelModal && (
        <CreateReelModal
          isOpen={showReelModal}
          onClose={handleReelClose}
          onSubmit={handleReelSubmit}
        />
      )}

      {/* Meeting Modal */}
      {showMeetingModal && (
        <CreateMeetingModal
          isOpen={showMeetingModal}
          onClose={handleMeetingClose}
          onSubmit={handleMeetingSubmit}
        />
      )}
    </>
  );
};

export default CreateNewContentPage;
